<template>
    <div>
        <div class="form-info">
            <el-form :model="devcInfoForm" ref="voucherInfo">
                <div class="content-caption dashed">
                    <span>信息单</span>
                </div>
                <div class="form-row" v-if="isAdd">
                    <div class="form-label">
                        <label>信息单模版</label>
                    </div>
                    <div class="form-value">
                        <div class="pos-rel" style="width: 470px">
                            <el-input class="bottom-line width-1-5x" v-model="tplName" :disabled="true"></el-input>
                            <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择信息单模版" @click="tplDlg()"></i>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-label">
                        <label class="required">名称</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="name" :rules="{validator: checkNull, trigger: 'blur'}">
                            <el-input type="text" v-model="devcInfoForm.name" style="width:415px;" placeholder="请输入名称"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="content-caption dashed" style="margin-top: 50px;">
                    <span>信息单项</span>
                </div>
                <table class="custom-tbl error-prompt">
                    <thead class="head">
                    <tr class="row">
                        <th class="required" width="500">标签</th>
                        <th class="required">内容</th>
                        <th width="120">操作</th>
                    </tr>
                    </thead>
                    <tbody class="body">
                    <tr v-for="(item,index) in devcInfoForm.itemList" class="row">
                        <td>
                            <el-form-item :prop="'itemList.' + index + '.label'" :rules="{required: true, type : 'string', message: '标签不能为空', trigger: 'blur'}">
                                <el-input type="text" v-model="item.label"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <el-form-item :prop="'itemList.' + index + '.value'" :rules="{required: true, type : 'string', message: '内容不能为空', trigger: 'blur'}">
                                <el-input type="textarea" v-model="item.value"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                            <i class="icon iconfont icon-arrow-top swb-btn swb-btn-link" @click="moveUpItem(index, true)"></i>
                            <i class="icon iconfont icon-arrow-bottom swb-btn swb-btn-link" @click="moveUpItem(index, false)"></i>
                            <div @click="removeItem(index);" class="swb-btn swb-btn-link">移除</div>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot class="foot">
                    <tr class="row">
                        <td colspan="3" style="padding: 10px; border: 1px solid #dfe6ec; text-align: center;">
                            <div @click="addItem();" class="swb-btn swb-btn-link">
                                <i class="icon iconfont icon-jiahao mr5"></i>
                                <a>添加</a>
                            </div>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </el-form>
        </div>
    </div>
</template>

<script>
    import { Utils} from '../../app.base'
    import { Vue, MsgBox , Routes } from '../../app.vues'

    import shopDevcApi from '../../api/shopDevc'

    import { openDevcInfoFormTplSelectDlg } from './selectDlg'

    export default {
        name: 'swb-devc-info-form-save',
        desc: '设备信息单保存',
        props: {
            devcId: {
                type: Number,
                deafult: null
            },
            devcNo: {
                type: String,
                deafult: null
            },
            id: {
                type: Number,
                deafult: null
            }
        },
        data: function () {
            return {
                devcInfoForm: {
                    devcId: null,
                    devcNo: null,
                    name: null,
                    itemList: []
                },
                tplId: null,
                tplName: null,
                isAdd: true
            }
        },
        created: function () {
            let id = this.id;
            if(id != null) {
                this.isAdd = false;
                // 修改
                this.getDevcInfoForm();
            } else {
                let devcInfoForm = this.devcInfoForm;
                devcInfoForm.devcId = this.devcId;
                devcInfoForm.devcNo = this.devcNo;
            }
        },
        methods: {
            getDevcInfoForm(){
                let self = this;
                let postData = {};
                postData.id = this.id;
                let theLoading = MsgBox.loading();
                shopDevcApi.getDevcInfoForm(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        self.devcInfoForm = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            checkNull: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            },
            addItem(){
                let itemList = this.devcInfoForm.itemList;
                let addItem = {
                    formId: this.id,
                    devcId: this.devcId
                };
                itemList.push(addItem);
                this.devcInfoForm.itemList = Utils.merge([], itemList);
            },
            handleSeqNo(){
                let itemList = this.devcInfoForm.itemList;
                itemList.forEach(function (item, index, array) {
                    array[index].seqNo = index + 1;
                });
                this.devcInfoForm.itemList = Utils.merge([], itemList);
            },
            removeItem(index) {
                let itemList = this.devcInfoForm.itemList;
                itemList.splice(index, 1);
                this.devcInfoForm.itemList = Utils.merge([], itemList);
            },
            moveUpItem(index, move){
                let itemList = this.devcInfoForm.itemList;
                let currItem = Utils.merge({}, itemList[index]);
                if(move) {
                    if(index != 0) {
                        let upItem = Utils.merge({}, itemList[index - 1]);
                        itemList[index] = upItem;
                        itemList[index - 1] = currItem;
                    }
                } else {
                    if(index != itemList.length - 1) {
                        let dwItem = Utils.merge({}, itemList[index + 1]);
                        itemList[index] = dwItem;
                        itemList[index + 1] = currItem;
                    }
                }
                this.devcInfoForm.itemList = Utils.merge([], itemList);
            },
            getDlgResult(){
                let self = this;
                let result = {
                    type: "info",
                    data: null
                };
                this.$refs['voucherInfo'].validate(function (valid) {
                    if(valid) {
                        let itemList = self.devcInfoForm.itemList;
                        if(itemList == null || itemList.length == 0) {
                            self.$message.warning("请填写信息单项");
                            result.type = "wran";
                        } else {
                            self.handleSeqNo();
                            result.data = self.devcInfoForm;
                        }
                    } else {
                        result.type = "wran";
                    }
                });
                return result;
            },
            tplDlg(){
                let self = this;
                openDevcInfoFormTplSelectDlg(this.tplId, function (tpl) {
                    if(self.tplId == tpl.id) {
                        return;
                    }
                    let postData = {};
                    postData.id = tpl.id;
                    let theLoading = MsgBox.loading();
                    shopDevcApi.getDevcInfoFormTpl(postData, function (result) {
                        theLoading.close();
                        if(result.type == "info") {
                            self.hancleTpl(result.data);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    })
                });
            },
            hancleTpl(tpl){
                let self = this;
                this.tplId = tpl.id;
                this.tplName = tpl.name;
                let devcInfoForm = this.devcInfoForm;
                devcInfoForm.name = tpl.name;
                let itemList = [];
                tpl.itemList.forEach(function (tplItem) {
                    let addItem = {
                        formId: self.id,
                        devcId: self.devcId,
                        label: tplItem.label
                    };
                    itemList.add(addItem);
                });
                devcInfoForm.itemList = itemList;
                this.devcInfoForm = Utils.merge({}, devcInfoForm);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/DevcInfoFormSave.vue